// TODO: this should potentially be owned analytics-middleware
import { call, select } from 'redux-saga/effects';
import MemberGroup from '@peloton/auth/models/MemberGroup';
import type { User } from '@peloton/auth/models/user';
import { isSignedIn } from '@peloton/auth/models/user';
import { getUser } from '@peloton/auth/redux';
import { identify } from '@members/analytics/api';

const PELOTON_EMAIL_DOMAINS = ['@onepeloton.com', '@pelotoncycle.com'];

const toFormattedLinkedAccountName = (socialProviderName?: string) => {
  if (socialProviderName === 'apple') {
    return 'Apple';
  } else if (socialProviderName === 'google-oauth2') {
    return 'Google';
  }
  return '';
};

/** True if the user belongs to an internal/tester member group. */
const toIsTester = (user: User): boolean =>
  isSignedIn(user) &&
  (user.memberGroups.includes(MemberGroup.InternalBetaTester) ||
    user.memberGroups.includes(MemberGroup.ExternalBetaTester));

/**
 * True if the user's email is a Peloton internal address.
 * Used to set "Is Employee" on the Amplitude user profile so chart filters
 * can exclude internal users.
 */
const toIsEmployee = (user: User): boolean =>
  isSignedIn(user) &&
  PELOTON_EMAIL_DOMAINS.some(domain => user.email?.toLowerCase().endsWith(domain));

export const analyticsIdentifySaga = function* () {
  const user: User = yield select(getUser);

  if (isSignedIn(user)) {
    yield call(identify, {
      id: user.id,
      linkedSocialAccount: toFormattedLinkedAccountName(
        (user as any)?.socialConnections?.[0]?.socialProviderName,
      ),
      isTester: toIsTester(user),
      isEmployee: toIsEmployee(user),
      email: user.email,
    });
  }
};
